import React from 'react';
import LegalDocument from '@/components/LegalDocument';

export default function Privacy() {
  return <LegalDocument document="privacy" />;
}
